import stockAPI from "@/utility/api.js";
import { termInChinese } from "@/utility/termInChinese.js";
export const reportQuarter = {
  state: {
    reportQuarter: [
      {
        company_name: "",
        stock_symbol: null,
        quarter_balance_sheets: [
          {
            accounts_and_bills_payable: "",
            accounts_and_bills_receivable: "",
            bank_loan_non_current: "",
            cash_and_cash_equivalents: "",
            commercial_paper_payable_acceptance_bill: "",
            corporate_bond: "",
            current_assets: "",
            current_liabilities: "",
            current_tax_liabilities: "",
            financial_liabilities_non_current: "",
            inventories: "",
            loan_to_other_S_T: "",
            long_term_investments: "",
            long_term_liabilities_due_within_one_year: "",
            non_current_assets: "",
            non_current_liabilities: "",
            other_current_assets: "",
            other_current_liabilities: "",
            other_equity: "",
            other_financial_liabilities_current: "",
            other_long_term_debt_payable_non_current: "",
            other_non_current_assets: "",
            other_payables: "",
            other_receivables: "",
            prepaid_expenses_and_repayments: "",
            property_plant_and_equipment: "",
            retained_earnings: "",
            share_capital: "",
            short_term_debt: "",
            short_term_financial_liability_current: "",
            short_term_investment_financial_assets_current: "",
            total_assets: "",
            total_capital_investment_IC: "",
            total_capital_reserve: "",
            total_equity: "",
            total_goodwill_and_intangible_assets: "",
            total_intangible_assets: "",
            total_liabilities: "",
            total_liabilities_and_stockholders_equity: "",
            total_other_L_T_liab: "",
            treasury_stock: "",
            quarter: ""
          }
        ],
        quarter_income_statements: [
          {
            EBIDTA: "",
            EPS: "",
            consolidated_net_income: "",
            cost_of_goods_sold: "",
            earnings_before_interest_and_tax: "",
            gains_and_losses_from_continuing_operations: "",
            income_before_tax: "",
            income_tax_expense: "",
            net_operating_revenue: "",
            operating_expenses: "",
            operating_income: "",
            other_comprehensive_income_OCI: "",
            other_gains_and_losses: "",
            realized_gross_profit: "",
            total_comprehensive_income: "",
            net_income_to_stockholders_company: "",
            comprehensive_income_to_stockholders_company: "",
            total_non_operating_revenue_and_expense: "",
            quarter: "",
            EPS_of_recently_four_seasons: ""
          }
        ],
        quarter_cash_flow_statements: [
          {
            amortization_CFO: "",
            cash_dividends_paids_CFF: "",
            cash_flow_during_this_period: "",
            cash_flow_from_fundraising: "",
            cash_flow_from_investment_activities: "",
            cash_flows_from_operations: "",
            decrease_increase_in_accounts_receivable_CFO: "",
            decrease_increase_in_inventories_CFO: "",
            depreciation_CFO: "",
            disposals_of_property_plant_equipment_include_prepaid_CFI: "",
            increase_decrease_in_account_payable_CTO: "",
            profit_before_tax_CFO: "",
            purchases_of_property_plant_equipment_include_prepaid_CFI: "",
            quarter: ""
          }
        ]
      }
    ],
    errorMessageWithQuarter: null
  },
  getters: {
    reportQuarter: state => state.reportQuarter,
    errorMessageWithQuarter: state => state.errorMessageWithQuarter,
    balanceSheetsQuarter: ({ reportQuarter: [{ quarter_balance_sheets }] }) =>
      quarter_balance_sheets,
    incomeStatementsQuarter: ({
      reportQuarter: [{ quarter_income_statements }]
    }) => quarter_income_statements,
    cashFlowStatementsQuarter: ({
      reportQuarter: [{ quarter_cash_flow_statements }]
    }) => quarter_cash_flow_statements,
    fieldsOfBalanceSheetsQuarter: (state, getters) =>
      getters.fieldsOfQuarter(getters.balanceSheetsQuarter),
    fieldsOfIncomeStatementsQuarter: (state, getters) =>
      getters.fieldsOfQuarter(getters.incomeStatementsQuarter),
    fieldsOfCashFlowStatementsQuarter: (state, getters) =>
      getters.fieldsOfQuarter(getters.cashFlowStatementsQuarter),
    itemsOfBalanceSheetsQuarter: (state, getters) =>
      getters.formatOfReportQuarter(getters.balanceSheetsQuarter),
    layerOfBalanceSheetsQuarter: (state, getters) =>
      getters.layerOfTableArea(getters.itemsOfBalanceSheetsQuarter),
    itemsOfIncomeStatementsQuarter: (state, getters) => {
      const tableBaseData = getters.formatOfReportQuarter(
        getters.incomeStatementsQuarter
      );
      //欄位排順序，歸屬母公司淨利（損）、綜合損益歸屬母公司要在本期綜合損益總額下方，稅前息前淨利上方
      const newItem1Idx = tableBaseData.findIndex(item =>
        item.subTitle.includes("歸屬母公司淨利")
      );
      const newitem1 = tableBaseData.splice(newItem1Idx, 1)[0];
      const newItem2Idx = tableBaseData.findIndex(item =>
        item.subTitle.includes("綜合損益歸屬母公司")
      );
      const newitem2 = tableBaseData.splice(newItem2Idx, 1)[0];
      const insertItemIdx = tableBaseData.findIndex(
        item => item.subTitle === "稅前息前淨利"
      );
      tableBaseData.splice(insertItemIdx, 0, newitem1, newitem2);

      /****************************************************************************
       * key: EPS_of_recently_four_seasons
       * 中文名稱在損益表-季表叫「近四季每股盈餘-完全稀釋-EPS」
       * 在選股列表、termInChinese.js 叫「近四季每股EPS」
       *****************************************************************************/
      return tableBaseData.map(item => {
        if (item.subTitle === "近四季每股EPS") {
          item.subTitle = "近四季每股盈餘-完全稀釋-EPS";
          return item;
        } else {
          return item;
        }
      });
    },
    layerOfIncomeStatementsQuarter: (state, getters) =>
      getters.layerOfTableArea(getters.itemsOfIncomeStatementsQuarter),
    itemsOfCashFlowStatementsQuarter: (state, getters) =>
      getters.formatOfReportQuarter(getters.cashFlowStatementsQuarter),
    layerOfCashFlowStatementsQuarter: (state, getters) =>
      getters.layerOfTableArea(getters.itemsOfCashFlowStatementsQuarter),
    formatOfReportQuarter: () => dataSets => {
      return Object.keys(dataSets.slice().shift())
        .filter(field => field !== "quarter")
        .map(field => {
          return dataSets.reduce((init, current) => {
            return {
              ...init,
              subTitle: termInChinese.get(field),
              [current.quarter]: current[field] === null ? "NA" : current[field]
            };
          }, {});
        });
    }
  },
  mutations: {
    reportQuarter(state, res) {
      state.reportQuarter = res;
    },
    errorMessageWithQuarter(state, res) {
      state.errorMessageWithQuarter = res || "";
    }
  },
  actions: {
    async FETCH_REPORT_QUARTER({ commit, rootState }) {
      try {
        const res = await stockAPI.GET(
          `/api/report/quarter/${rootState.stockSymbol}`
        );
        commit("reportQuarter", res);
        // 共用 rootState 儲存股票代號。
        commit("storageCompanyName", res, { root: true });
        commit("errorMessageWithQuarter", null);
      } catch ({ message }) {
        commit("errorMessageWithQuarter", message);
        console.error(message);
      }
    }
  }
};
